import http from "./httpService";
import { apiUrl } from "config/envConfig";

const base = `${apiUrl}/order-mgmt/admin/deliverypricing`;

export const getAllDeliveryPricingOptions = async (
  pageNumber = 1,
  pageSize = 10,
  orderType = null,
  isSenderOption = null
) => {
  const payload = {
    pageNumber,
    pageSize,
  };

  if (orderType !== null && orderType !== undefined) {
    payload.OrderType = orderType;
  }

  if (isSenderOption !== null && isSenderOption !== undefined) {
    payload.IsSenderOption = isSenderOption;
  }

  const { data } = await http.post(`${base}/all`, payload);
  return data.data;
};

export const getDeliveryPricingOptionById = async (id) => {
  const { data } = await http.get(`${base}/${id}`);
  return data.data;
};

export const getActiveDeliveryPricingOption = async (optionNumber) => {
  const { data } = await http.get(`${base}/active/${optionNumber}`);
  return data.data;
};

export const createDeliveryPricingOption = async (payload, orderType = null) => {
  const body = { ...payload };

  if (orderType !== null && orderType !== undefined) {
    body.OrderType = orderType;
  }

  const { data } = await http.post(`${base}/create`, body);
  return data.data;
};

export const updateDeliveryPricingOption = async (payload, orderType = null) => {
  const body = { ...payload };

  if (orderType !== null && orderType !== undefined) {
    body.OrderType = orderType;
  }

  const { data } = await http.put(`${base}/update`, body);
  return data.data;
};

export const activateDeliveryPricingOption = async (id, orderType = null) => {
  const body = {};

  if (orderType !== null && orderType !== undefined) {
    body.OrderType = orderType;
  }

  const { data } = await http.post(`${base}/activate/${id}`, body);
  return data.data;
};

export const deactivateDeliveryPricingOption = async (id) => {
  const { data } = await http.post(`${base}/deactivate/${id}`);
  return data.data;
};

export const deleteDeliveryPricingOption = async (id) => {
  const { data } = await http.delete(`${base}/${id}`);
  return data.data;
};

const deliveryPricingService = {
  getAllDeliveryPricingOptions,
  getDeliveryPricingOptionById,
  getActiveDeliveryPricingOption,
  createDeliveryPricingOption,
  updateDeliveryPricingOption,
  activateDeliveryPricingOption,
  deactivateDeliveryPricingOption,
  deleteDeliveryPricingOption,
};

export default deliveryPricingService;
